import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectDetailsDomain = state => state.detailsReducer || initialState;

export const getIsDetailsLoadingSelector = () =>
	createSelector(selectDetailsDomain, ({ isDetailsLoading }) => isDetailsLoading);

export const getDetailsSelector = () => createSelector(selectDetailsDomain, ({ details }) => details);

export const getDetailsSearchValueSelector = () =>
	createSelector(selectDetailsDomain, ({ detailsSearchValue }) => detailsSearchValue);

export const getRawPaginationSelector = () => createSelector(selectDetailsDomain, ({ pagination }) => pagination);

export const getPaginationSelector = () =>
	createSelector(selectDetailsDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});
